import { render, staticRenderFns } from "./VrstaTeme2Forma.vue?vue&type=template&id=37b10646&scoped=true&"
import script from "./VrstaTeme2Forma.vue?vue&type=script&lang=js&"
export * from "./VrstaTeme2Forma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b10646",
  null
  
)

export default component.exports